export default __webpack_public_path__ + "static/media/modely10.a890e6cd.jpg";